import * as actionTypes from "../constants/actionTypes";
import { Item } from "../reducers/items";

export interface GetSharedLinksAction {
  type: "GET_SHARED_LINKS";
  payload: {
    nid: string;
    fids: Array<string>;
    exp: number;
  };
}
export interface GetSharedLinksSuccessAction {
  type: "GET_SHARED_LINKS_SUCCESS";
  payload: {
    links: Array<Object>;
  };
}
export interface GetSharedLinksErrorAction {
  type: "GET_SHARED_LINKS_ERROR";
  payload: { error: string; status: number };
}
export interface ShowShareModalAction {
  type: "SHOW_SHARE_MODAL";
  payload: { visible: boolean; item: Item | null | undefined };
}

export type Action =
  | GetSharedLinksAction
  | GetSharedLinksSuccessAction
  | GetSharedLinksErrorAction
  | ShowShareModalAction;

export function getSharedLinks(nid: string, fids: Array<string>, exp: number) {
  return {
    type: actionTypes.GET_SHARED_LINKS,
    payload: {
      nid,
      fids,
      exp
    }
  };
}

export function getSharedLinksSuccess(links: Array<Object>): Action {
  return {
    type: actionTypes.GET_SHARED_LINKS_SUCCESS,
    payload: {
      links
    }
  };
}

export function getSharedLinksError(error: string, status: number): Action {
  return {
    type: actionTypes.GET_SHARED_LINKS_ERROR,
    payload: {
      error,
      status
    }
  };
}

export function showShareModal(
  visible: boolean,
  item: Item | null | undefined
): Action {
  return {
    type: actionTypes.SHOW_SHARE_MODAL,
    payload: {
      visible,
      item
    }
  };
}
